import { useTLang } from 'intl/intl';

export function useZappieChipLang() {
  return {
    label: useTLang({ id: 'order.chip.zappie' }),
  };
}
